import type { i18n } from 'i18next';
import assetsTabDe from './AssetsTab/de.json';
import assetsTabEn from './AssetsTab/en.json';
import assetsTabEs from './AssetsTab/es.json';
import assetsTabFr from './AssetsTab/fr.json';
import assetsTabNl from './AssetsTab/nl.json';
import batteryCommandsPanelDe from './BatteryCommandsPanel/de.json';
import batteryCommandsPanelEn from './BatteryCommandsPanel/en.json';
import batteryCommandsPanelEs from './BatteryCommandsPanel/es.json';
import batteryCommandsPanelFr from './BatteryCommandsPanel/fr.json';
import batteryCommandsPanelNl from './BatteryCommandsPanel/nl.json';
import batteryOverviewPanelDe from './BatteryOverviewPanel/de.json';
import batteryOverviewPanelEn from './BatteryOverviewPanel/en.json';
import batteryOverviewPanelEs from './BatteryOverviewPanel/es.json';
import batteryOverviewPanelFr from './BatteryOverviewPanel/fr.json';
import batteryOverviewPanelNl from './BatteryOverviewPanel/nl.json';
// import batteryTabDe from './BatteryTab/de.json';
import batteryTabEn from './BatteryTab/en.json';
import commandWithSelectDe from './CommandWithSelect/de.json';
import commandWithSelectEn from './CommandWithSelect/en.json';
import commandWithSelectEs from './CommandWithSelect/es.json';
import commandWithSelectFr from './CommandWithSelect/fr.json';
import commandWithSelectNl from './CommandWithSelect/nl.json';
import commandWithValueDe from './CommandWithValue/de.json';
import commandWithValueEn from './CommandWithValue/en.json';
import commandWithValueEs from './CommandWithValue/es.json';
import commandWithValueFr from './CommandWithValue/fr.json';
import commandWithValueNl from './CommandWithValue/nl.json';
import configTableDe from './ConfigTable/de.json';
import configTableEn from './ConfigTable/en.json';
import configTableEs from './ConfigTable/es.json';
import configTableFr from './ConfigTable/fr.json';
import configTableNl from './ConfigTable/nl.json';
import configTableDialogDe from './ConfigTableDialog/de.json';
import configTableDialogEn from './ConfigTableDialog/en.json';
import configTableDialogEs from './ConfigTableDialog/es.json';
import configTableDialogFr from './ConfigTableDialog/fr.json';
import configTableDialogNl from './ConfigTableDialog/nl.json';
import diagramPowerFlowDe from './DiagramPowerFlow/de.json';
import diagramPowerFlowEn from './DiagramPowerFlow/en.json';
import diagramPowerFlowEs from './DiagramPowerFlow/es.json';
import diagramPowerFlowFr from './DiagramPowerFlow/fr.json';
import diagramPowerFlowNl from './DiagramPowerFlow/nl.json';
import externalEnergyMeterConfigPanelDe from './ExternalEnergyMeterConfigPanel/de.json';
import externalEnergyMeterConfigPanelEn from './ExternalEnergyMeterConfigPanel/en.json';
import externalEnergyMeterConfigPanelEs from './ExternalEnergyMeterConfigPanel/es.json';
import externalEnergyMeterConfigPanelFr from './ExternalEnergyMeterConfigPanel/fr.json';
import externalEnergyMeterConfigPanelNl from './ExternalEnergyMeterConfigPanel/nl.json';
import externalGensetCommandsPanelDe from './ExternalGensetCommandsPanel/de.json';
import externalGensetCommandsPanelEn from './ExternalGensetCommandsPanel/en.json';
import externalGensetCommandsPanelEs from './ExternalGensetCommandsPanel/es.json';
import externalGensetCommandsPanelFr from './ExternalGensetCommandsPanel/fr.json';
import externalGensetCommandsPanelNl from './ExternalGensetCommandsPanel/nl.json';
import externalGensetConfigPanelDe from './ExternalGensetConfigPanel/de.json';
import externalGensetConfigPanelEn from './ExternalGensetConfigPanel/en.json';
import externalGensetConfigPanelEs from './ExternalGensetConfigPanel/es.json';
import externalGensetConfigPanelFr from './ExternalGensetConfigPanel/fr.json';
import externalGensetConfigPanelNl from './ExternalGensetConfigPanel/nl.json';
import loadBankConfigPanelDe from './LoadBankConfigPanel/de.json';
import loadBankConfigPanelEn from './LoadBankConfigPanel/en.json';
import loadBankConfigPanelEs from './LoadBankConfigPanel/es.json';
import loadBankConfigPanelFr from './LoadBankConfigPanel/fr.json';
import loadBankConfigPanelNl from './LoadBankConfigPanel/nl.json';
import modalDe from './Modal/de.json';
import modalEn from './Modal/en.json';
import modalEs from './Modal/es.json';
import modalFr from './Modal/fr.json';
import modalNl from './Modal/nl.json';
import powerTabDe from './PowerTab/de.json';
import powerTabEn from './PowerTab/en.json';
import powerTabEs from './PowerTab/es.json';
import powerTabFr from './PowerTab/fr.json';
import powerTabNl from './PowerTab/nl.json';
// import batteryTabEs from './BatteryTab/es.json';
// import batteryTabFr from './BatteryTab/fr.json';
// import batteryTabNl from './BatteryTab/nl.json';
import programWizardDe from './ProgramWizard/de.json';
import programWizardEn from './ProgramWizard/en.json';
import programWizardEs from './ProgramWizard/es.json';
import programWizardFr from './ProgramWizard/fr.json';
import programWizardNl from './ProgramWizard/nl.json';
import radioToggleWithConfirmationDe from './RadioToggleWithConfirmation/de.json';
import radioToggleWithConfirmationEn from './RadioToggleWithConfirmation/en.json';
import radioToggleWithConfirmationEs from './RadioToggleWithConfirmation/es.json';
import radioToggleWithConfirmationFr from './RadioToggleWithConfirmation/fr.json';
import radioToggleWithConfirmationNl from './RadioToggleWithConfirmation/nl.json';
import relayConfigPanelDe from './RelayConfigPanel/de.json';
import relayConfigPanelEn from './RelayConfigPanel/en.json';
import relayConfigPanelEs from './RelayConfigPanel/es.json';
import relayConfigPanelFr from './RelayConfigPanel/fr.json';
import relayConfigPanelNl from './RelayConfigPanel/nl.json';
import restrictedNumberFieldDe from './RestrictedNumberField/de.json';
import restrictedNumberFieldEn from './RestrictedNumberField/en.json';
import restrictedNumberFieldEs from './RestrictedNumberField/es.json';
import restrictedNumberFieldFr from './RestrictedNumberField/fr.json';
import restrictedNumberFieldNl from './RestrictedNumberField/nl.json';
import searchInputDe from './SearchInput/de.json';
import searchInputEn from './SearchInput/en.json';
import searchInputEs from './SearchInput/es.json';
import searchInputFr from './SearchInput/fr.json';
import searchInputNl from './SearchInput/nl.json';

type SupportedLanguage = 'en' | 'nl' | 'es' | 'fr' | 'de';

/** Each entry maps directly to an i18next namespace owned by that ui-library component. */
const componentTranslations: Record<string, Record<SupportedLanguage, object>> = {
  assetsTab: {
    en: assetsTabEn,
    nl: assetsTabNl,
    es: assetsTabEs,
    fr: assetsTabFr,
    de: assetsTabDe,
  },
  batteryCommandsPanel: {
    en: batteryCommandsPanelEn,
    nl: batteryCommandsPanelNl,
    es: batteryCommandsPanelEs,
    fr: batteryCommandsPanelFr,
    de: batteryCommandsPanelDe,
  },
  batteryOverviewPanel: {
    en: batteryOverviewPanelEn,
    nl: batteryOverviewPanelNl,
    es: batteryOverviewPanelEs,
    fr: batteryOverviewPanelFr,
    de: batteryOverviewPanelDe,
  },
  // TODO: nl/es/fr/de translations for BatteryTab will be added later - fall back to English for now.
  batteryTab: { en: batteryTabEn, nl: batteryTabEn, es: batteryTabEn, fr: batteryTabEn, de: batteryTabEn },
  commandWithSelect: {
    en: commandWithSelectEn,
    nl: commandWithSelectNl,
    es: commandWithSelectEs,
    fr: commandWithSelectFr,
    de: commandWithSelectDe,
  },
  commandWithValue: {
    en: commandWithValueEn,
    nl: commandWithValueNl,
    es: commandWithValueEs,
    fr: commandWithValueFr,
    de: commandWithValueDe,
  },
  configTable: {
    en: configTableEn,
    nl: configTableNl,
    es: configTableEs,
    fr: configTableFr,
    de: configTableDe,
  },
  configTableDialog: {
    en: configTableDialogEn,
    nl: configTableDialogNl,
    es: configTableDialogEs,
    fr: configTableDialogFr,
    de: configTableDialogDe,
  },
  externalEnergyMeterConfigPanel: {
    en: externalEnergyMeterConfigPanelEn,
    nl: externalEnergyMeterConfigPanelNl,
    es: externalEnergyMeterConfigPanelEs,
    fr: externalEnergyMeterConfigPanelFr,
    de: externalEnergyMeterConfigPanelDe,
  },
  externalGensetCommandsPanel: {
    en: externalGensetCommandsPanelEn,
    nl: externalGensetCommandsPanelNl,
    es: externalGensetCommandsPanelEs,
    fr: externalGensetCommandsPanelFr,
    de: externalGensetCommandsPanelDe,
  },
  externalGensetConfigPanel: {
    en: externalGensetConfigPanelEn,
    nl: externalGensetConfigPanelNl,
    es: externalGensetConfigPanelEs,
    fr: externalGensetConfigPanelFr,
    de: externalGensetConfigPanelDe,
  },
  loadBankConfigPanel: {
    en: loadBankConfigPanelEn,
    nl: loadBankConfigPanelNl,
    es: loadBankConfigPanelEs,
    fr: loadBankConfigPanelFr,
    de: loadBankConfigPanelDe,
  },
  modal: { en: modalEn, nl: modalNl, es: modalEs, fr: modalFr, de: modalDe },
  powerTab: { en: powerTabEn, nl: powerTabNl, es: powerTabEs, fr: powerTabFr, de: powerTabDe },
  programWizard: {
    en: programWizardEn,
    nl: programWizardNl,
    es: programWizardEs,
    fr: programWizardFr,
    de: programWizardDe,
  },
  relayConfigPanel: {
    en: relayConfigPanelEn,
    nl: relayConfigPanelNl,
    es: relayConfigPanelEs,
    fr: relayConfigPanelFr,
    de: relayConfigPanelDe,
  },
  radioToggleWithConfirmation: {
    en: radioToggleWithConfirmationEn,
    nl: radioToggleWithConfirmationNl,
    es: radioToggleWithConfirmationEs,
    fr: radioToggleWithConfirmationFr,
    de: radioToggleWithConfirmationDe,
  },
  restrictedNumberField: {
    en: restrictedNumberFieldEn,
    nl: restrictedNumberFieldNl,
    es: restrictedNumberFieldEs,
    fr: restrictedNumberFieldFr,
    de: restrictedNumberFieldDe,
  },
  searchInput: { en: searchInputEn, nl: searchInputNl, es: searchInputEs, fr: searchInputFr, de: searchInputDe },
  diagramPowerFlow: {
    en: diagramPowerFlowEn,
    nl: diagramPowerFlowNl,
    es: diagramPowerFlowEs,
    fr: diagramPowerFlowFr,
    de: diagramPowerFlowDe,
  },
};

/**
 * Registers ui-library component translations into the provided i18next instance.
 *
 * Call this once in each app's i18n setup before rendering. Uses deep merge with
 * overwrite=false so any app-level translation always wins over the ui-library default.
 *
 * @example — projects-fe
 *   import { addUiLibraryTranslations } from 'greener-ui-library';
 *   addUiLibraryTranslations(i18n, ['en', 'nl']);
 *
 * @example — HMI
 *   import { addUiLibraryTranslations } from 'greener-ui-library';
 *   addUiLibraryTranslations(i18n, ['en', 'nl', 'es', 'fr', 'de']);
 */
export const addUiLibraryTranslations = (i18nInstance: i18n, languages: SupportedLanguage[] = ['en', 'nl']): void => {
  Object.entries(componentTranslations).forEach(([ns, translations]) => {
    languages.forEach((lng) => {
      i18nInstance.addResourceBundle(lng, ns, translations[lng] ?? translations.en, true, false);
    });
  });
};
